import { createSlice } from "@reduxjs/toolkit";
import Api from "services/api";

export const initialState = {
    messages: [],
    interpreters: [],
    loader: false,
    interpretersLoader: false,
    error: null,
};

export const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setMessages: (state, { payload }) => {
            state.messages = payload ?? [];
        },
        setInterpreters: (state, { payload }) => {
            state.interpreters = Array.isArray(payload)
                ? payload
                : Array.isArray(payload?.data)
                    ? payload.data
                    : [];
        },
        addMessageToStore: (state, { payload }) => {
            state.messages.push(payload);
        },
        setLoader: (state, { payload }) => {
            state.loader = payload;
        },
        setInterpretersLoader: (state, { payload }) => {
            state.interpretersLoader = payload;
        },
        updateInterpreterLastMessage: (state, { payload }) => {
            const { receiver_id, message, created_at } = payload;

            const index = state.interpreters.findIndex(
                (item) => item.id === receiver_id
            );

            if (index !== -1) {
                const updated = state.interpreters[index];

                updated.last_message = message;
                updated.last_time = created_at;

                state.interpreters.splice(index, 1);

                state.interpreters.unshift(updated);
            }
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
        clearChat: (state) => {
            state.messages = [];
            state.interpreters = [];
            state.error = null;
        },
    },
});

export const {
    setMessages,
    setInterpreters,
    addMessageToStore,
    setLoader,
    setInterpretersLoader,
    updateInterpreterLastMessage,
    setError,
    clearChat,
} = chatSlice.actions;

// ✅ Thunk: Fetch messages for a specific user
export const fetchChatMessages = (receiverId) => async (dispatch) => {
    dispatch(setLoader(true));
    try {
        const result = await Api.fetchChatMessages(receiverId);
        if (result.status >= 200 && result.status < 300) {
            dispatch(setMessages(result.data.data));
        } else {
            dispatch(setError(result.data));
        }
    } catch (error) {
        dispatch(setError(error));
    } finally {
        dispatch(setLoader(false));
    }
};

export const fetchAdminChatInterpreters = () => async (dispatch) => {
    dispatch(setInterpretersLoader(true));
    try {
        const result = await Api.fetchChatInterpreters();

        if (result.status >= 200 && result.status < 300) {
            dispatch(setInterpreters(result.data.data));
        }
    } finally {
        dispatch(setInterpretersLoader(false));
    }
};

export const sendChatMessage = (data, callback) => async (dispatch) => {
    try {
        const result = await Api.sendChatMessage(data);
        if (result.status >= 200 && result.status < 300) {
            dispatch(addMessageToStore(result.data.data));

            dispatch(updateInterpreterLastMessage({
                receiver_id: data.receiver_id,
                message: result.data.data.message,
                created_at: result.data.data.created_at
            }));

            if (callback) callback(true, result.data.message);
        } else {
            if (callback) callback(false, result.data.message);
        }
    } catch (error) {
        if (callback) callback(false, "Message send karne mein masla hua.");
    }
};

export const fetchInterpreterChatMessages = (interpreterId) => async (dispatch) => {
    dispatch(setLoader(true));

    try {
        const result = await Api.fetchInterpreterChatMessages(interpreterId);

        if (result.status >= 200 && result.status < 300) {
            dispatch(setMessages(result.data.data));
        } else {
            dispatch(setError(result.data));
        }
    } catch (error) {
        dispatch(setError(error));
    } finally {
        dispatch(setLoader(false));
    }
};

export const sendInterpreterChatMessage = (data, callback) => async (dispatch) => {
    try {
        const result = await Api.sendInterpreterChatMessage(data);
        if (result.status >= 200 && result.status < 300) {
            dispatch(addMessageToStore(result.data.data));
            if (callback) callback(true, result.data.message);
        } else {
            if (callback) callback(false, result.data.message);
        }
    } catch (error) {
        if (callback) callback(false, "Message bhejte waqt masla hua.");
    }
};

export default chatSlice.reducer;
export const chatSelector = (state) => state.chat;
